const guiColors = {
    'motion-primary': '#5a00ff',
    'motion-primary-transparent': 'hsla(261, 100%, 50%, 0.35)',
    'motion-tertiary': '#4600c7',

    'looks-secondary': '#5a00ff',
    'looks-secondary-light': '#7e39fd',
    'looks-secondary-lighter': '#a16ffb',
    'looks-transparent': 'hsla(289, 100%, 39%, 0.15)',
    'looks-light-transparent': 'hsla(261, 100%, 50%, 0.15)',
    'looks-secondary-dark': '#5900ff',
    'looks-secondary-darker': '#4002b3',
    'looks-secondary-deep-dark': '#240066',

    'extensions-primary': 'hsla(261, 100%, 50%, 1)',
    'extensions-tertiary': 'hsla(261, 100%, 39%, 1)',
    'extensions-transparent': 'hsla(261, 100%, 50%, 0.35)',
    'extensions-light': '#7e39fd',

    'drop-highlight': '#722bf5'
};

const blockColors = {
    checkboxActiveBackground: '#5a00ff',
    checkboxActiveBorder: '#4b05ca'
};

export {
    guiColors,
    blockColors
};